document.addEventListener('DOMContentLoaded', function() {
  // Accessibility enhancements
  initExternalLinks();
  focusOnSuccessMessage();
  });
function initExternalLinks() {
  const links = document.querySelectorAll("a[href]");

  links.forEach((link) => {
    try {
      const href = link.getAttribute("href");
      if (!href) return;

      if (
        href.startsWith("#") ||
        href.startsWith("/") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:")
      ) {
        return;
      }

      const url = new URL(href, window.location.origin);

      if (url.hostname !== window.location.hostname) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");

        const label = link.getAttribute("aria-label") || link.textContent.trim();
        link.setAttribute("aria-label", `${label}, opens in a new tab`);
      }
    } catch (err) {
      console.error("initExternalLinks: skipped a link due to error", link, err);
    }
  });
}
function focusOnSuccessMessage() {
  const successMessage = document.getElementById("ContactFormSuccess");
  if(!successMessage) return;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      successMessage.focus();
    });
  });
}
 window.addEventListener("load", function () {
  const errorMessage =
    document.getElementById("login-form-error") ||
    document.getElementById("register-form-error");

  if (!errorMessage) return;

  let count = 0;

  const focusInterval = setInterval(function () {
    errorMessage.focus();
    count++;

    if (count >= 10) {
      clearInterval(focusInterval);
    }
  }, 100);
});